import React, { Component } from "react";
import PropTypes from "prop-types";
import * as DOMPurify from "dompurify";

export class StarterCampaignPreviewStep extends Component {
  static propTypes = {
    step: PropTypes.object.isRequired,
    templates: PropTypes.array,
    smsTemplates: PropTypes.array,
    index: PropTypes.number
  };

  constructor(props) {
    super(props);
    this.state = { showStepDetail: false };
  }

  findTemplate(step) {
    if (step.medium == "email") {
      const templates = this.props.templates;
      const template = templates.find(t => t.id == step.email_template_id);
      return template;
    } else if (step.medium == "sms") {
      const smsTemplates = this.props.smsTemplates;
      const smsTemplate = smsTemplates.find(t => t.id == step.sms_template_id);
      return smsTemplate;
    }
  }

  stepDetail(step, template) {
    if (this.state.showStepDetail) {
      let subject = "";
      let details = "";
      if (step.medium == "manual") {
        subject = step.medium_data["medium_title"] || "";
        details = step.medium_data["medium_description"] || "";
      } else if (step.medium == "email") {
        subject = template.subject;
        details = template.body;
      } else if (step.medium == "sms") {
        details = template.body_text;
      }



      /* eslint-disable import/namespace */
      return (
        <div className="well">
          <div className={`m-b-5 ${step.medium == "sms" ? "hide" : ""}`}>
            <label>Title:</label>
            <br />
            {subject}
          </div>
          <div>
            <label>Description:</label>
            <br />
            <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(details) }} />
          </div>
        </div>
      );
      /* eslint-enable import/namespace */
    }
  }

  toggleStepDetail() {
    const { showStepDetail } = this.state;
    const toggle = !showStepDetail;
    this.setState({ showStepDetail: toggle });
  }

  stepMedium(step) {
    return step.medium == "manual" ? "Follow-up" : step.medium;
  }

  stepTitle(step, template) {
    if (template) {
      return template.name;
    } else if (step.medium_data) {
      return step.medium_data["medium_title"];
    }
  }

  render() {
    const { step, index } = this.props;
    let stepNumber = index + 1;
    const template = this.findTemplate(step);
    return (
      <tbody>
        <tr>
          <td>{stepNumber}</td>
          <td>
            Wait: {step.delay_value} {step.delay_unit}
          </td>
          <td className={step.medium == "sms" ? "uppercase" : "capitalize"}>
            {this.stepMedium(step)}
          </td>
          <td>{this.stepTitle(step, template)}</td>
          <td>
            <a
              style={{ cursor: "pointer" }}
              onClick={this.toggleStepDetail.bind(this)}
            >
              View Details
            </a>
          </td>
        </tr>
        <tr>
          <td colSpan={5}>{this.stepDetail(step, template)}</td>
        </tr>
      </tbody>
    );
  }
}

export default StarterCampaignPreviewStep;
